import React, { useState } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, FormControl, FormLabel, Input, VStack, useToast,
} from '@chakra-ui/react';
import { authApi } from '../services/api';

// Troca de senha do próprio usuário (valida a senha atual no backend).
const ChangePasswordModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const toast = useToast();
  const [cur, setCur] = useState('');
  const [nw, setNw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const reset = () => { setCur(''); setNw(''); setConfirm(''); };
  const close = () => { reset(); onClose(); };

  const submit = async () => {
    if (nw.length < 8) {
      toast({ title: 'A nova senha deve ter no mínimo 8 caracteres', status: 'warning', duration: 3000 });
      return;
    }
    if (nw !== confirm) {
      toast({ title: 'As senhas novas não conferem', status: 'warning', duration: 3000 });
      return;
    }
    setLoading(true);
    try {
      await authApi.changePassword(cur, nw);
      toast({ title: 'Senha alterada com sucesso', status: 'success', duration: 4000, isClosable: true });
      close();
    } catch (e: any) {
      toast({ title: 'Não foi possível alterar', description: e?.response?.data?.detail || 'Tente novamente', status: 'error', duration: 5000, isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={close} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Trocar senha</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <FormControl isRequired>
              <FormLabel fontSize="sm">Senha atual</FormLabel>
              <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} autoComplete="current-password" />
            </FormControl>
            <FormControl isRequired>
              <FormLabel fontSize="sm">Nova senha</FormLabel>
              <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} autoComplete="new-password" placeholder="Mínimo 8 caracteres" />
            </FormControl>
            <FormControl isRequired>
              <FormLabel fontSize="sm">Confirmar nova senha</FormLabel>
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={close}>Cancelar</Button>
          <Button colorScheme="brand" onClick={submit} isLoading={loading}>Salvar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ChangePasswordModal;
